import React,{useState, useEffect} from "react";
import { Calendar as Calender, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import axios from "axios";

const localizer = momentLocalizer(moment);

function DoctoronCalender(){
    const [appointments, setAppointments] = useState([]);
    const [currentDate, setCurrentDate] = useState(new Date());

    useEffect(()=>{
        const fetchAppointments = async () => {
            try {
                const response = await axios.get("https://api.swasthmitra.com/api/appointment/appointments");
                setAppointments(response.data);
            } catch (error) {
                console.error("Error fetching appointments:", error);
            }
        };
        fetchAppointments();
        
    }, []);

    const event = appointments.map((appointment) => ({
        title: `${appointment.doctorName} - ${appointment.hospitalName}`,
        start: new Date(appointment.appointmentDate),
        end: new Date(appointment.appointmentDate).getTime() + 30 * 60 * 1000,
        desc: `${appointment.address} | ${appointment.hospitalName}` 
    }));
     
    return (
    <div style={{ height: "700px", margin: "50px" }}>
        <Calender localizer={localizer} events={event}
        date={currentDate}
        onNavigate={(date)=> setCurrentDate(date)}
        startAccessor="start" endAccessor="end" style={{ height: "700" }} />
    </div>
    // <div>
       
    //     <select value={currentDate.getMonth}></select>
    // </div>
);
}


export default DoctoronCalender;
 